import routes from '../../routes/routes.js'
import sidebarLinks from '../../sidebarLinks'
import eventBus from './eventBus.js'
import PermissionHelper from './Permissions/permissionHelper'
import {SharedPermissionHelper} from './Permissions/SharedPermissionHelper'

export default class MenuAndRoutesBuilder {
  static instance
  newRoutes = null
  sph = SharedPermissionHelper.getInstance()

  static getInstance () {
    if (this.instance === undefined) {
      this.instance = new MenuAndRoutesBuilder()
    }
    return this.instance
  }

  constructor () {
    this.newRoutes = null
  }

  RetrieveRoutesAndSideBarLinks () {
    let param = []
    let routePermissions = this.RetrieveRoutePermissions(false)
    for (let i = 0; i < routePermissions.length; i++) {
      let permissionData = this.StripPermission(routePermissions[i])
      if (permissionData.permission !== null) {
        param.push(permissionData.permission)
      }
    }
    return new Promise((resolve, reject) => {
      PermissionHelper.methods.retrievePermissions(param).then((permissions) => {
        this.sph.loadList(true, false).then(
          () => {
            this.BuildRoutes()
            resolve(permissions)
          }
        ).catch((err) => {
          reject(err)
        })
      }).catch((err) => {
        reject(err)
      })
    })
  }

  BuildRoutes () {
    let bckRoutes = JSON.parse(JSON.stringify(routes))
    let tmpRoutes = []
    for (let a = 0; a < bckRoutes.length; a++) {
      let tmpRoute = bckRoutes[a]
      let parentPermissions = this.GetPermissions(tmpRoute)
      let children = this.GetChildren(tmpRoute)
      let tmpChildren = []
      if (parentPermissions.length === 0 && children.length === 0) {
        tmpRoutes.push(tmpRoute)
      } else {
        let hasParentPermission = parentPermissions.length === 0
        // check parent permissions - logical OR
        for (let i = 0; i < parentPermissions.length; i++) {
          // missing permission for parent
          if (this.CheckPermission(parentPermissions[i], tmpRoute.additionalDataRequired) === true) {
            hasParentPermission = true
            break
          }
        }
        // missing all necessary parent permissions
        if (hasParentPermission === false) {
          continue
        }
        // check children permissions
        for (let i = 0; i < children.length; i++) {
          // check all childrens permissions
          let childPermissions = this.GetPermissions(children[i])
          let hasChildPermissions = true
          if (childPermissions.length > 0) {
            hasChildPermissions = false
          }
          /* v primeru večih zahtevanih pravic se upošteva logični ALI med additionalData posameznih pravic */
          for (let j = 0; j < childPermissions.length; j++) {
            if (this.CheckPermission(childPermissions[j], children[i].additionalDataRequired) === true) {
              hasChildPermissions = true
            }
          }
          let accessWithRequests = this.GetAccessPermissions(children[i])
          for (let j = 0; j < accessWithRequests.length; j++) {
            if (this.CheckPermissionSharedWithMe(accessWithRequests[j]) === true) {
              hasChildPermissions = true
            }
          }
          // we have all necessary permissions for a specific child
          if (hasChildPermissions === true) {
            tmpChildren.push(children[i])
          }
        }
        if (tmpChildren.length > 0) {
          tmpRoute.children = tmpChildren
        } else {
          tmpRoute.children = null
        }
        /* skip the parent that has children but doesn`t have permission for a single one of them */
        if (children.length > 0 && tmpChildren.length === 0) {
          continue
        }
        tmpRoutes.push(tmpRoute)
      }
    }
    this.newRoutes = tmpRoutes
    this.BuildSidebarLinks()
  }

  BuildSidebarLinks () {
    let bckLinks = JSON.parse(JSON.stringify(sidebarLinks))
    let tmpSidebarLinks = []
    for (let i = 0; i < bckLinks.length; i++) {
      let tmpSideBarLink = bckLinks[i]
      let children = this.GetChildren(tmpSideBarLink)
      let tmpChildren = []
      // check parent path
      if (typeof tmpSideBarLink.path !== 'undefined' && this.FindPathInRoutes(tmpSideBarLink.path) === false) {
        continue
      }
      // check childrens path
      for (let j = 0; j < children.length; j++) {
        this.FindPathInRoutes(children[j].path).then(pathExists => {
          if (pathExists === true) {
            tmpChildren.push(children[j])
          }
        })
        tmpSideBarLink.children = tmpChildren
      }
      tmpSidebarLinks.push(tmpSideBarLink)
    }
    eventBus.$emit('SIDEBAR_LOADED', tmpSidebarLinks)
  }

  FindPathInRoutes (path, returnPath = false) {
    if (this.newRoutes === null) {
      return new Promise((resolve, reject) => {
        this.RetrieveRoutesAndSideBarLinks().then(retrievedRoutes => {
          this.FindPathInRoutes(path, returnPath).then(findPathResult => {
            resolve(findPathResult)
          }).catch((err) => {
            reject(err)
          })
        }).catch(err => {
          reject(err)
        })
      })
    } else {
      return new Promise((resolve, reject) => {
        let searchArray = this.newRoutes
        path = path.split('/')
        let parent = ''
        let child = ''
        if (path.length === 3) {
          parent = '/' + path[1]
          child = path[2]
        } else if (path.length === 2) {
          parent = '/' + path[1]
        } else {
          resolve(false)
        }

        for (let i = 0; i < searchArray.length; i++) {
          if (searchArray[i].path === parent) {
            if (child.length > 0) {
              for (let j = 0; j < searchArray[i].children.length; j++) {
                if (searchArray[i].children[j].path === child) {
                  if (returnPath) {
                    resolve(searchArray[i].children[j])
                  }
                  resolve(true)
                }
              }
            } else {
              resolve(true)
            }
          }
        }
        resolve(false)
      })
    }
  }

  CheckPermission (permissionId, additionalDataRequired = false) {
    let permission = this.StripPermission(permissionId)
    if (permission === false) {
      return false
    }
    return PermissionHelper.methods.HasPermission(permission.permission, additionalDataRequired, permission.filter, permission.filter_value)
  }

  CheckPermissionSharedWithMe (permissionId) {
    try {
      return this.sph.hasPendingSharedPermissionRequest(permissionId)
    } catch (e) {
      return false
    }
  }

  StripPermission (permissionId) {
    if (typeof permissionId === 'undefined' || permissionId === null || permissionId === '') {
      return false
    }
    let permission = { permission: null, filter: null, filter_value: null }
    let startBracketPosition = permissionId.indexOf('[')
    if (startBracketPosition !== -1) {
      permission.permission = permissionId.substr(0, startBracketPosition)
      let endBracketPosition = permissionId.indexOf(']')
      if (endBracketPosition !== -1) {
        permission.filter = permissionId.substr(startBracketPosition + 1, (endBracketPosition - startBracketPosition - 1))
      }
      let valuePosition = permissionId.indexOf('=')
      if (valuePosition !== -1) {
        permission.filter_value = permissionId.substr(valuePosition + 1)
      }
    } else {
      permission.permission = permissionId
    }
    return permission
  }

  GetPermissions (element, checkChildren = false) {
    let permissions = []
    if (typeof element.permissions !== 'undefined') {
      permissions = Object.values(element.permissions)
    }
    if (checkChildren) {
      let childElements = this.GetChildren(element)
      for (let i = 0; i < childElements.length; i++) {
        permissions = permissions.concat(this.GetPermissions(childElements[i], checkChildren))
      }
    }
    permissions = this.RemoveDuplicatesFromArray(permissions)

    return permissions
  }

  GetAccessPermissions (element, checkChildren = false) {
    let permissions = []
    if (typeof element.accessWithPermissionRequests !== 'undefined') {
      permissions = Object.values(element.accessWithPermissionRequests)
    }
    if (checkChildren) {
      let childElements = this.GetChildren(element)
      for (let i = 0; i < childElements.length; i++) {
        permissions = permissions.concat(this.GetAccessPermissions(childElements[i], checkChildren))
      }
    }
    permissions = this.RemoveDuplicatesFromArray(permissions)

    return permissions
  }

  GetChildren (element) {
    if (typeof element.children !== 'undefined' && element.children.constructor === Array) {
      return element.children
    } else {
      return []
    }
  }

  RemoveDuplicatesFromArray (arrayOfValues) {
    if (Array.isArray(arrayOfValues)) {
      return Array.from(new Set(arrayOfValues))
    }

    return false
  }

  CanNavigate (path) {
    return new Promise((resolve) => {
      this.FindPathInRoutes(path).then(canNavigate => {
        resolve(canNavigate)
      })
    })
  }

  RetrieveRoutePermissions (returnOnlyIds = true) {
    let permissionsArray = []
    for (let i = 0; i < routes.length; i++) {
      permissionsArray = permissionsArray.concat(this.GetPermissions(routes[i], true))
    }
    permissionsArray = this.RemoveDuplicatesFromArray(permissionsArray)
    if (returnOnlyIds) {
      let result = []
      for (let i = 0; i < permissionsArray.length; i++) {
        let perm = this.StripPermission(permissionsArray[i])
        result.push(perm.permission)
      }
      permissionsArray = result
    }
    return permissionsArray
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/menuAndRoutesBuilder.js